"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keywordLinker = void 0;
const PARKING_SPACE_APPLY = {
    name: '泊车位申请',
    url: 'https://fuwu.chinagoods.com/boothService/parking/index',
    desc: '市场泊车位线上办理，省时省心',
    icon: 'icon-bocheweishenqingicon',
};
const OPEN_STORE = {
    name: '店铺开店',
    url: 'https://bp.chinagoods.com/business-settle',
    desc: '店铺开店流程相关讲解',
    icon: 'icon-dianpukaidianicon',
};
const PHYSICAL_MARKET = {
    name: '实体市场',
    url: 'https://www.chinagoods.com/markets',
    desc: '市场相关信息展示',
    icon: 'icon-shitishichangicon',
};
const MARKET_PAYMENT = {
    name: '市场缴费',
    url: 'https://fuwu.chinagoods.com/quotientFees/index',
    desc: '线上市场缴费，省心又省力',
    icon: 'icon-shichangjiaofeiicon',
};
const MARKET_PROMOTION = {
    name: '市场招商',
    url: 'https://news.chinagoods.com/information/11',
    desc: '市场招商简报，快速掌握市场招商信息',
    icon: 'icon-shichangzhaoshangicon',
};
const SUBLEASING = {
    name: '转租转让',
    url: 'https://fuwu.chinagoods.com/lease/index',
    desc: '商位转租转让信息查看',
    icon: 'icon-zhuanzuzhuanrangicon',
};
const ELECTRICITY_METER_RECHARGE = {
    name: '电表充值',
    url: 'https://fuwu.chinagoods.com/electricityFees/index',
    desc: '商位电表线上充值',
    icon: 'icon-dianbiaochongzhiicon',
};
const keywordLinker = (key) => {
    switch (key) {
        case '泊车':
        case '停车位':
        case '停车位申请':
        case '泊车位':
        case '泊车位申请':
            return [PARKING_SPACE_APPLY];
        case '义乌购':
        case '开店':
        case '产业带入驻':
            return [OPEN_STORE];
        case '市场':
            return [PHYSICAL_MARKET, MARKET_PAYMENT, MARKET_PROMOTION];
        case '实体市场':
            return [PHYSICAL_MARKET];
        case '市场缴费':
            return [MARKET_PAYMENT];
        case '市场招商':
            return [MARKET_PROMOTION];
        case '摊位出租':
        case '摊位':
        case '店铺出租':
        case '转租转让':
        case '出租':
            return [SUBLEASING];
        case '电费':
        case '电表':
        case '充电费':
        case '充电表':
        case '电表充值':
        case '电费充值':
            return [ELECTRICITY_METER_RECHARGE];
        default:
            return [];
    }
};
exports.keywordLinker = keywordLinker;
//# sourceMappingURL=keyword-linker.js.map